// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module__frac--KtS4y{font-size:.75em;opacity:.7}`, "",{"version":3,"sources":["webpack://./src/common/components/amt/style.module.scss"],"names":[],"mappings":"AAAA,2BACE,eAAA,CACA,UAAA","sourcesContent":[".frac {\n  font-size: 0.75em;\n  opacity: 0.7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"frac": `style-module__frac--KtS4y`
};
export default ___CSS_LOADER_EXPORT___;
